import * as R from 'ramda'

import { treeToDb, dbToTree } from 'src/lib/graph/walk'

import * as notificationFormSelectors from 'src/components/user/NotificationSettings/selectors'
const { paths } = notificationFormSelectors

export const updateNotificationSettings = (
  state,
  { payload: { userId, base, result, fragment } }
) => {
  const savedSettings = dbToTree(userId, fragment, state)

  const {
    ':user/notification-settings': savedNotificationSettings
  } = savedSettings

  const newNotificationSettings = R.map(
    R.ifElse(
      R.propSatisfies(R.is(Number), ':db/id'),
      R.identity,
      R.evolve({
        ':db/id': tempId => R.prop(tempId, result)
      })
    ),
    R.prop(paths.NOTIFICATION_SETTINGS, base)
  ).filter(R.propSatisfies(val => !R.isNil(val), ':db/id'))

  const transactedIdMap = R.reduce(
    (acc, notificationSetting) => ({
      ...acc,
      [R.prop(':db/id', notificationSetting)]: notificationSetting
    }),
    {},
    newNotificationSettings
  )

  const concatNotificationSettings = R.uniqBy(
    R.prop(':db/id'),
    R.concat(savedNotificationSettings, newNotificationSettings)
  )

  const finalNotificationSettings = R.map(
    notificationSetting =>
      R.propOr(
        notificationSetting,
        R.prop(':db/id', notificationSetting),
        transactedIdMap
      ),
    concatNotificationSettings
  )

  const finalData = {
    ...base,
    [paths.NOTIFICATION_SETTINGS]: finalNotificationSettings
  }

  const newFlattenedDb = treeToDb(fragment, finalData)

  return R.mergeDeepRight(state, newFlattenedDb)
}

export const deleteNotificationSettings = (
  state,
  { payload: { ids, userId } }
) =>
  R.pipe(
    R.evolve({
      [userId]: {
        ':user/notification-settings': R.without(ids)
      }
    }),
    R.omit(ids)
  )(state)
